(function(){
'use strict';

var C = window.HavjoyCore;
if (!C) return;

var modal = document.getElementById('personalize-modal');
var fileInput = document.getElementById('file-input');
if (!modal || !fileInput) return;
var isTeeBundleBuilder = !!document.querySelector('[data-tee-bundle-builder="true"]');
var isTeeMultiPhoto = !!document.querySelector('[data-tee-multi-photo="true"]');
var isTeeSinglePhoto = !!document.querySelector('.hj-tee-product') && !isTeeMultiPhoto;
var MULTI_PHOTO_MAX = 8;
var MULTI_PHOTO_MIN = 4;

var dataEl = document.getElementById('product-variants-data');
if (!dataEl) return;
var productJson;
try { productJson = JSON.parse(dataEl.textContent); } catch(e) { console.warn('HJ: product-variants-data parse failed', e); return; }
var isLikelyTeeProduct = !!document.getElementById('tee-form') ||
  !!document.querySelector('.hj-tee-product');
if (!isTeeMultiPhoto && isLikelyTeeProduct) {
  isTeeSinglePhoto = true;
}
if (productJson && productJson.handle === 'proud-father-dass-tshirt') {
  isTeeBundleBuilder = true;
}

var BUNDLE_MULTIPLIERS = { single: 1, duo: 0.85, trio: 0.80 };
var BUNDLE_QUANTITIES  = { single: 1, duo: 2,    trio: 3    };

// ===== STATE =====
function createPositionState(overrides) {
  return Object.assign({
    variantId: null, variantTitle: null, price: 0, comparePrice: 0,
    personalizeImage: null, listGenerated: [], productHandle: null,
    options: {}, optionLabels: {}, uploadedUrl: null, uploadedUrls: [], localPhotos: [], galleryIndex: 0,
    printType: 'canvas', sizeKey: '9x12', editingGenerated: false
  }, overrides);
}

var ALL_PRODUCTS = {};
ALL_PRODUCTS[productJson.handle] = {
  title: productJson.title,
  image: productJson.featured_image,
  variants: productJson.variants.map(function(v) {
    return { title: v.title, id: String(v.id), price: v.price, comparePrice: v.compare_at_price || v.price };
  })
};

var state = {
  selectedBundle: 'single',
  positions: {
    1: createPositionState({ productHandle: productJson.handle }),
    2: createPositionState({ productHandle: productJson.handle }),
    3: createPositionState({ productHandle: productJson.handle })
  },
  positionCache: {}
};

var activePosition = null;
var intervals = {};
var optionsCache = {};
var variantCardsHandle = null;
var uploader = new C.Uploader();
var $ = function(s) { return document.querySelector(s); };
var $$ = function(s) { return document.querySelectorAll(s); };

// ===== MODAL ELEMENT CACHE =====
var modalEls = {
  hacard:          modal.querySelector('.hacard'),
  loadingArea:     modal.querySelector('.loading-area'),
  mainImage:       modal.querySelector('.main-image'),
  confirmBtn:      modal.querySelector('.confirm-btn'),
  uploadedPreview: modal.querySelector('.uploaded-image-preview'),
  uploadedPreviewImg: modal.querySelector('.uploaded-preview-img'),
  modalFooter:     modal.querySelector('.modal-footer'),
  prevBtn:         modal.querySelector('.prev-btn'),
  nextBtn:         modal.querySelector('.next-btn'),
  variantOption:   modal.querySelector('#variant-option-container'),
  designActions:   modal.querySelector('.hj-design-actions'),
  optionsContainer:modal.querySelector('.product-options-container'),
  dynamicForm:     modal.querySelector('.dynamic-options-form'),
  productHandle:   modal.querySelector('.product-handle'),
  multiPicker:     modal.querySelector('[data-multi-photo-picker]'),
  multiGrid:       modal.querySelector('[data-multi-photo-grid]'),
  multiCount:      modal.querySelector('[data-multi-photo-count]'),
  singlePicker:    modal.querySelector('[data-single-photo-picker]'),
  singleGrid:      modal.querySelector('[data-single-photo-grid]'),
  reuseNote:       modal.querySelector('[data-reuse-upload-note]'),
  previewHistory:  modal.querySelector('[data-preview-history]'),
  previewHistoryRow: modal.querySelector('[data-preview-history-row]'),
};
var pdpVariantPicker = document.querySelector('[data-hj-pdp-variant-picker]');
var usesPdpVariantPicker = !!pdpVariantPicker;

function ensureTeeModalMarkup() {
  if (!isTeeTemplateMode()) return;

  var headline = modal.querySelector('.hj-modal-headline');
  if (headline) headline.innerHTML = 'Personalize your <em>tee.</em>';

  if (modalEls.uploadedPreview) {
    modalEls.uploadedPreview.hidden = true;
    modalEls.uploadedPreview.style.display = 'none';
  }

  if (isTeeSinglePhoto && (!modalEls.singlePicker || !modalEls.singleGrid)) {
    var picker = document.createElement('div');
    picker.className = 'hj-multi-upload hj-multi-upload--single';
    picker.setAttribute('data-single-photo-picker', '');
    picker.hidden = true;
    picker.innerHTML =
      '<div class="hj-multi-upload__head"><p class="hj-multi-upload__sub">Add your photo to start</p></div>' +
      '<button type="button" class="hj-multi-upload__reuse-note caption-small" data-reuse-upload-note data-action="reuse-upload-new" hidden>Re-upload</button>' +
      '<div class="hj-multi-upload__grid hj-multi-upload__grid--single" data-single-photo-grid></div>';

    var anchor = modal.querySelector('.img-cards') || modalEls.optionsContainer || modalEls.modalFooter;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(picker, anchor);
    else modal.querySelector('.modal-content').appendChild(picker);

    modalEls.singlePicker = picker;
    modalEls.singleGrid = picker.querySelector('[data-single-photo-grid]');
    modalEls.reuseNote = picker.querySelector('[data-reuse-upload-note]');
  }

  if (modalEls.confirmBtn) {
    var label = modalEls.confirmBtn.querySelector('.btn-text');
    if (label && /art/i.test(label.textContent || '')) label.textContent = 'Next';
  }
}

ensureTeeModalMarkup();

function isMultiPhotoActive() {
  return isTeeMultiPhoto && modalEls.multiPicker && modalEls.multiGrid;
}

function isSinglePhotoActive() {
  return isTeeSinglePhoto && modalEls.singlePicker && modalEls.singleGrid;
}

function isTeeTemplateMode() {
  return isTeeMultiPhoto || isTeeSinglePhoto;
}

function isStepActive(step) {
  var el = modal.querySelector('.hj-step[data-step="' + step + '"]');
  return !!(el && el.classList.contains('active'));
}

function setReuseNote(show, count) {
  if (!modalEls.reuseNote) return;
  modalEls.reuseNote.hidden = !show;
  if (show) modalEls.reuseNote.textContent = 'Re-upload';
}

function setUploadedPreviewVisible(show, src) {
  if (!modalEls.uploadedPreview) return;
  if (src && modalEls.uploadedPreviewImg) modalEls.uploadedPreviewImg.src = src;
  modalEls.uploadedPreview.hidden = !show;
  modalEls.uploadedPreview.style.display = show ? 'block' : 'none';
}

function syncTeeUploadNextState(posData) {
  if (!isTeeTemplateMode() || !modalEls.confirmBtn || !isStepActive(1)) return;

  var hasEnoughPhotos = true;
  if (isMultiPhotoActive()) {
    hasEnoughPhotos = (posData.localPhotos || []).length >= MULTI_PHOTO_MIN;
  } else if (isSinglePhotoActive()) {
    hasEnoughPhotos = (posData.localPhotos || []).length > 0 || !!posData.uploadedUrl;
  }

  modalEls.confirmBtn.classList.remove('loading');
  modalEls.confirmBtn.disabled = !hasEnoughPhotos;
  var label = modalEls.confirmBtn.querySelector('.btn-text');
  if (label) label.textContent = 'Next';
}

function normalizeUploadedUrls(value) {
  return C.normalizeUploadedUrls ? C.normalizeUploadedUrls(value) : [];
}

function photosNeedUpload(posData) {
  return (posData.localPhotos || []).some(function(photo) { return !!photo.file; });
}

function syncUploadedUrlsFromPhotos(posData) {
  var urls = (posData.localPhotos || [])
    .filter(function(photo) { return photo.uploadedUrl && !photo.file; })
    .map(function(photo) { return photo.uploadedUrl; });
  posData.uploadedUrls = urls;
  posData.uploadedUrl = urls[0] || null;
}

function setReusedSinglePhoto(posData, url) {
  if (!url || !isSinglePhotoActive()) return false;
  revokeLocalPhotos(posData);
  posData.localPhotos = [{ previewUrl: url, uploadedUrl: url, reused: true }];
  posData.uploadedUrl = url;
  posData.uploadedUrls = [];
  renderSinglePhotoTile(posData);
  setReuseNote(true, 1);
  return true;
}

function setReusedMultiPhotos(posData, urls) {
  if (!isMultiPhotoActive()) return false;
  var validUrls = normalizeUploadedUrls(urls).slice(0, MULTI_PHOTO_MAX);
  if (!validUrls.length) return false;

  revokeLocalPhotos(posData);
  posData.localPhotos = validUrls.map(function(url) {
    return { previewUrl: url, uploadedUrl: url, reused: true };
  });
  posData.uploadedUrls = validUrls;
  posData.uploadedUrl = validUrls[0] || null;
  renderMultiPhotoGrid(posData);
  setReuseNote(true, validUrls.length);
  return true;
}

function copyMainUploadToPosition(posData) {
  var source = state.positions[1];
  if (!source || !posData || posData.uploadedUrl || (posData.localPhotos || []).length) return false;

  var urls = [];
  if (Array.isArray(source.uploadedUrls) && source.uploadedUrls.length) {
    urls = source.uploadedUrls.slice();
  } else if (source.uploadedUrl) {
    urls = [source.uploadedUrl];
  }

  if (!urls.length) return false;

  if (isMultiPhotoActive()) return setReusedMultiPhotos(posData, urls);
  if (isSinglePhotoActive()) return setReusedSinglePhoto(posData, urls[0]);

  posData.uploadedUrl = urls[0];
  posData.uploadedUrls = [];
  return true;
}

function prefillLatestUpload(posData) {
  if (posData.personalizeImage || posData.uploadedUrl || (posData.localPhotos || []).length) {
    return Promise.resolve(false);
  }

  return C.getLatestUploadedUrls()
    .then(function(urls) {
      if (!urls.length) return false;
      if (isMultiPhotoActive()) {
        return setReusedMultiPhotos(posData, urls);
      }

      if (isSinglePhotoActive()) {
        return setReusedSinglePhoto(posData, urls[0]);
      }

      posData.uploadedUrl = urls[0];
      posData.uploadedUrls = [];
      return true;
    })
    .catch(function(error) {
      console.warn('HJ: latest upload reuse unavailable', error);
      return false;
    });
}

function renderPreviewHistory(posData) {
  if (!isTeeTemplateMode() || !modalEls.previewHistory || !modalEls.previewHistoryRow) return;

  var list = posData.listGenerated || [];
  if (list.length < 2) {
    modalEls.previewHistory.hidden = true;
    modalEls.previewHistoryRow.innerHTML = '';
    return;
  }

  modalEls.previewHistory.hidden = false;
  modalEls.previewHistoryRow.innerHTML = '';
  list.forEach(function(url, index) {
    var thumb = document.createElement('button');
    thumb.type = 'button';
    thumb.className = 'hj-preview-history__thumb' + (index === posData.galleryIndex ? ' is-active' : '');
    thumb.dataset.previewIndex = String(index);
    thumb.setAttribute('aria-label', 'Choose preview ' + (index + 1));
    thumb.innerHTML = '<img src="' + url + '" alt="">';
    modalEls.previewHistoryRow.appendChild(thumb);
  });
}

function selectPreviewHistory(posData, index) {
  var list = posData.listGenerated || [];
  if (index < 0 || index >= list.length) return;

  posData.galleryIndex = index;
  posData.personalizeImage = list[index];
  if (modalEls.mainImage) modalEls.mainImage.src = posData.personalizeImage;
  renderPreviewHistory(posData);
  if (activePosition !== null) {
    document.dispatchEvent(new CustomEvent('havjoy:personalize:complete', {
      detail: {
        position: activePosition,
        handle: posData.productHandle,
        imageUrl: posData.personalizeImage,
        variantId: posData.variantId,
        price: posData.price
      }
    }));
  }
}

function revokeLocalPhotos(posData) {
  (posData.localPhotos || []).forEach(function(photo) {
    if (photo.previewUrl && !photo.reused) URL.revokeObjectURL(photo.previewUrl);
  });
}

function renderMultiPhotoGrid(posData) {
  if (!isMultiPhotoActive()) return;

  var head = modalEls.multiPicker.querySelector('.hj-multi-upload__head');
  if (head) head.hidden = (posData.localPhotos || []).length > 0;
  modalEls.multiGrid.innerHTML = '';
  (posData.localPhotos || []).forEach(function(photo, index) {
    var tile = document.createElement('div');
    tile.className = 'hj-multi-upload__tile';
    tile.innerHTML = '<img src="' + photo.previewUrl + '" alt="Uploaded photo ' + (index + 1) + '"><button type="button" class="hj-multi-upload__remove" data-action="remove-multi-photo" data-index="' + index + '" aria-label="Remove photo">&times;</button>';
    modalEls.multiGrid.appendChild(tile);
  });

  if ((posData.localPhotos || []).length < MULTI_PHOTO_MAX) {
    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'hj-multi-upload__tile hj-multi-upload__add';
    add.setAttribute('data-action', 'add-multi-photo');
    add.innerHTML = '<span class="hj-multi-upload__add-icon">+</span><span>Add photo</span>';
    modalEls.multiGrid.appendChild(add);
  }

  if (modalEls.multiCount) {
    var count = (posData.localPhotos || []).length;
    modalEls.multiCount.textContent = count >= MULTI_PHOTO_MIN
      ? count + ' / ' + MULTI_PHOTO_MAX + ' photos · Ready to preview'
      : count + ' / ' + MULTI_PHOTO_MAX + ' photos · Minimum ' + MULTI_PHOTO_MIN + ' required';
  }
  setReuseNote((posData.localPhotos || []).some(function(photo) { return photo.reused; }), (posData.localPhotos || []).length);
  syncTeeUploadNextState(posData);
}

function addMultiPhotoFiles(posData, files) {
  if (!isMultiPhotoActive()) return;
  var selected = Array.prototype.slice.call(files || []);
  if (!selected.length) return;

  var current = (posData.localPhotos || []).length;
  var available = Math.max(0, MULTI_PHOTO_MAX - current);
  if (selected.length > available) C.showToast('You can upload up to 8 photos.', 'warning');

  selected.slice(0, available).forEach(function(file) {
    if (!file.type.startsWith('image/') && !uploader.isHeic(file)) {
      C.showToast('Please select image files only.', 'warning');
      return;
    }
    posData.localPhotos.push({
      file: file,
      previewUrl: URL.createObjectURL(file)
    });
  });

  posData.uploadedUrls = [];
  posData.uploadedUrl = null;

  renderMultiPhotoGrid(posData);
}

function renderSinglePhotoTile(posData) {
  if (!isSinglePhotoActive()) return;

  var head = modalEls.singlePicker.querySelector('.hj-multi-upload__head');
  if (head) head.hidden = (posData.localPhotos || []).length > 0;
  modalEls.singleGrid.innerHTML = '';
  var photo = posData.localPhotos && posData.localPhotos[0];
  if (photo) {
    var tile = document.createElement('div');
    tile.className = 'hj-multi-upload__tile';
    tile.innerHTML = '<img src="' + photo.previewUrl + '" alt="Uploaded photo"><button type="button" class="hj-multi-upload__remove" data-action="remove-single-photo" aria-label="Remove photo">&times;</button>';
    modalEls.singleGrid.appendChild(tile);
    setReuseNote(!!photo.reused, 1);
    syncTeeUploadNextState(posData);
    return;
  }

  var add = document.createElement('button');
  add.type = 'button';
  add.className = 'hj-multi-upload__tile hj-multi-upload__add';
  add.setAttribute('data-action', 'add-single-photo');
  add.innerHTML = '<span class="hj-multi-upload__add-icon">+</span><span>Add photo</span>';
  modalEls.singleGrid.appendChild(add);
  setReuseNote(false);
  syncTeeUploadNextState(posData);
}

function setSinglePhotoFile(posData, file) {
  if (!isSinglePhotoActive() || !file) return;
  if (!file.type.startsWith('image/') && !uploader.isHeic(file)) {
    C.showToast('Please select an image file.', 'warning');
    return;
  }

  revokeLocalPhotos(posData);
  posData.localPhotos = [{
    file: file,
    previewUrl: URL.createObjectURL(file)
  }];
  posData.uploadedUrls = [];
  posData.uploadedUrl = null;
  renderSinglePhotoTile(posData);
}

async function uploadSinglePhoto(posData) {
  if (!isSinglePhotoActive()) return true;
  var photo = posData.localPhotos && posData.localPhotos[0];
  if (posData.uploadedUrl && photo && !photo.file) return true;
  if (!photo) {
    C.showToast('Please upload a photo first.', 'warning');
    return false;
  }

  C.showUploadStatus(modal, 'Uploading your photo...');
  var res = await C.handleFileUpload(photo.file, uploader, modal);
  if (!res || !res.url) return false;

  C.hideUploadStatus(modal);
  posData.uploadedUrl = res.url;
  posData.uploadedUrls = [];
  return true;
}

async function uploadMultiPhotos(posData) {
  if (!isMultiPhotoActive()) return true;
  if (!posData.localPhotos || !posData.localPhotos.length) {
    C.showToast('Please upload at least ' + MULTI_PHOTO_MIN + ' photos.', 'warning');
    return false;
  }
  if (posData.localPhotos.length < MULTI_PHOTO_MIN) {
    C.showToast('Please upload at least ' + MULTI_PHOTO_MIN + ' photos.', 'warning');
    return false;
  }
  if (!photosNeedUpload(posData) && Array.isArray(posData.uploadedUrls) && posData.uploadedUrls.length >= MULTI_PHOTO_MIN) {
    posData.uploadedUrl = posData.uploadedUrls[0] || null;
    return true;
  }

  var uploadedUrls = [];
  var total = posData.localPhotos.length;
  C.showUploadStatus(modal, 'Uploading photo 1 of ' + total + '...');
  C.updateUploadStatus(modal, null, 0);
  for (var i = 0; i < posData.localPhotos.length; i++) {
    if (posData.localPhotos[i].uploadedUrl && !posData.localPhotos[i].file) {
      uploadedUrls.push(posData.localPhotos[i].uploadedUrl);
      C.updateUploadStatus(modal, 'Loaded photo ' + (i + 1) + ' of ' + total, Math.round(((i + 1) / total) * 100));
      continue;
    }
    var label = 'Uploading photo ' + (i + 1) + ' of ' + total + '...';
    C.updateUploadStatus(modal, label, Math.round((i / total) * 100));
    var res = await C.handleFileUpload(posData.localPhotos[i].file, uploader, modal, {
      externalStatus: true,
      onProgress: function(percent) {
        var overallPercent = Math.min(99, Math.round(((i + (percent || 0) / 100) / total) * 100));
        C.updateUploadStatus(modal, label, overallPercent);
      }
    });
    if (!res || !res.url) return false;
    uploadedUrls.push(res.url);
    C.updateUploadStatus(modal, 'Uploaded photo ' + (i + 1) + ' of ' + total, Math.round(((i + 1) / total) * 100));
  }

  C.updateUploadStatus(modal, 'Upload complete', 100);
  C.hideUploadStatus(modal);
  posData.uploadedUrls = uploadedUrls;
  posData.uploadedUrl = uploadedUrls[0] || null;
  if (C.saveRecentUploadedUrls) C.saveRecentUploadedUrls(uploadedUrls);
  return true;
}

function showDetailsStep(posData, pos) {
  C.hideUploadStatus(modal);
  if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
  if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
  setUploadedPreviewVisible(false);
  setReuseNote(false);
  if (modalEls.dynamicForm && modalEls.dynamicForm.dataset.handle !== posData.productHandle) {
    C.renderOptions(modalEls.dynamicForm, optionsCache[posData.productHandle] || []);
    modalEls.dynamicForm.dataset.handle = posData.productHandle;
  }
  if (modalEls.dynamicForm) modalEls.dynamicForm.style.display = '';
  C.setModalStep(modal, 2);
  if (modalEls.optionsContainer) modalEls.optionsContainer.style.display = 'block';
  if (modalEls.modalFooter) modalEls.modalFooter.style.display = '';
  if (modalEls.confirmBtn) {
    modalEls.confirmBtn.classList.remove('loading');
    modalEls.confirmBtn.disabled = false;
    var label = modalEls.confirmBtn.querySelector('.btn-text');
    if (label) label.textContent = isTeeMultiPhoto || isTeeSinglePhoto ? 'Preview My Tee' : 'Preview My Art';
  }
  updateAddonPrices(pos);
}

function skipDetailsAndGenerate(posData, pos) {
  posData.options = {};
  posData.optionLabels = {};
  if (modalEls.dynamicForm) modalEls.dynamicForm.innerHTML = '';
  if (modalEls.optionsContainer) modalEls.optionsContainer.style.display = 'none';
  startPreviewGeneration(posData, pos);
}

async function continueAfterOptionsLoaded(posData, pos) {
  var detailOptions = await loadProductOptions(pos, posData.productHandle);
  if (!detailOptions || detailOptions.length === 0) {
    skipDetailsAndGenerate(posData, pos);
    return;
  }
  showDetailsStep(posData, pos);
}

// ===== VARIANT CARD INJECTION =====
function fetchAndInjectVariantCards(handle) {
  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      ALL_PRODUCTS[handle] = {
        title: data.title,
        image: data.featured_image,
        variants: data.variants.map(function(v) {
          return { title: v.title, id: String(v.id), price: v.price, comparePrice: v.compare_at_price || v.price };
        })
      };
      variantCardsHandle = null;
      injectVariantCards(handle);
      if (activePosition !== null) updateAddonPrices(activePosition);
    })
    .catch(function(e) { console.error('Failed to fetch product data:', e); });
}

function injectVariantCards(handle) {
  if (!modalEls.variantOption) return;
  if (variantCardsHandle === handle && modalEls.variantOption && modalEls.variantOption.querySelector('.canvas-card')) return;
  var productData = ALL_PRODUCTS[handle];
  if (!productData) { fetchAndInjectVariantCards(handle); return; }
  C.injectVariantCards(modalEls.variantOption, productData);
  variantCardsHandle = handle;
}

function ensureVariantCards(handle) {
  if (!modalEls.variantOption) return;
  if (modalEls.variantOption.querySelector('.canvas-card') && modalEls.variantOption.querySelector('.download-now-btn')) return;
  variantCardsHandle = null;
  injectVariantCards(handle);
}

// ===== VARIANT LOOKUP =====
function findVariant(handle, searchPattern) {
  var productData = ALL_PRODUCTS[handle];
  if (!productData) return null;
  var pattern = searchPattern.toLowerCase();
  for (var i = 0; i < productData.variants.length; i++) {
    var v = productData.variants[i];
    if (v.title.toLowerCase().includes(pattern)) {
      return { id: v.id, title: v.title, price: v.price, comparePrice: v.comparePrice };
    }
  }
  return null;
}

function syncPdpVariantPicker(pos) {
  if (!usesPdpVariantPicker || pos !== 1) return;

  var posData = state.positions[pos];
  if (!posData) return;
  var printType = posData.printType || 'canvas';
  var sizeKey = posData.sizeKey || '9x12';
  var isDigital = printType === 'digital';
  var sizeOptions = pdpVariantPicker.querySelector('[data-pdp-size-options]');

  if (sizeOptions) sizeOptions.hidden = isDigital;

  pdpVariantPicker.querySelectorAll('[data-pdp-print-type]').forEach(function(button) {
    var isActive = button.dataset.pdpPrintType === printType;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });
  pdpVariantPicker.querySelectorAll('[data-pdp-size]').forEach(function(button) {
    var isActive = !isDigital && button.dataset.pdpSize === sizeKey;
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  document.dispatchEvent(new CustomEvent('havjoy:pdp-variant-change', {
    detail: {
      position: pos,
      handle: posData.productHandle,
      printType: printType,
      sizeKey: sizeKey,
      variantId: posData.variantId,
      price: posData.price,
      comparePrice: posData.comparePrice
    }
  }));
}

// ===== PRICING =====
function updateAddonPrices(pos) {
  var posData = state.positions[pos];
  var handle = posData.productHandle;
  var sizeKey = posData.sizeKey || '9x12';
  var printType = posData.printType || 'canvas';
  var multiplier = BUNDLE_MULTIPLIERS[state.selectedBundle] || 1;

  var variant = findVariant(handle, C.variantTitle(printType, sizeKey));
  if (!variant) return;

  posData.variantId = variant.id;
  posData.variantTitle = variant.title;
  posData.price = variant.price;
  posData.comparePrice = variant.comparePrice;

  var sizeInput = modal.querySelector('.addon-size[data-addon="canvas"]');
  var printTypeInput = modal.querySelector('.print-type-input');
  if (sizeInput) sizeInput.value = sizeKey;
  if (printTypeInput) printTypeInput.value = printType;

  var atcPriceEl = modal.querySelector('.canvas-atc-price-text');
  if (atcPriceEl) atcPriceEl.textContent = C.formatMoney(Math.round(variant.price * multiplier));

  var digitalVariant = findVariant(handle, C.VARIANT_DIGITAL);
  modal.querySelectorAll('.digital-base-price').forEach(function(el) {
    if (digitalVariant) el.textContent = C.formatMoney(Math.round(digitalVariant.price * multiplier));
  });

  var installmentEl = modal.querySelector('.modal-installment-text');
  if (installmentEl) {
    var price = Math.round(variant.price * multiplier);
    if (price > 0) {
      var interest = price > 5000 ? 4 : 2;
      var numEl = modal.querySelector('.modal-interest-num');
      var moneyEl = modal.querySelector('.modal-money-installment');
      if (numEl) numEl.textContent = interest;
      if (moneyEl) moneyEl.textContent = C.formatMoney(Math.round(price / interest));
      installmentEl.style.display = '';
    } else {
      installmentEl.style.display = 'none';
    }
  }
}

function updateBundlePrices() {
  $$('.bundle-card').forEach(function(card) {
    var bundle = card.dataset.bundle;
    var qty = BUNDLE_QUANTITIES[bundle];
    var multiplier = BUNDLE_MULTIPLIERS[bundle];
    var bundleTotal = card.querySelector('.bundle-total-price');
    if (!bundleTotal) return;
    var basePrice = parseInt(bundleTotal.dataset.basePrice) || 0;
    var totalPrice = 0;
    for (var i = 1; i <= qty; i++) totalPrice += Math.round((state.positions[i].price || basePrice) * multiplier);

    var allSelected = true;
    for (var i = 1; i <= qty; i++) { if (!state.positions[i].price) { allSelected = false; break; } }

    var discountBadge = card.querySelector('.bundle-discount-badge');
    var oldPriceEl = card.querySelector('.bundle-old-price');
    if (bundle === 'single' || allSelected) {
      bundleTotal.textContent = C.formatMoney(Math.round(totalPrice));
      bundleTotal.style.display = '';
      if (oldPriceEl) oldPriceEl.style.display = '';
      if (discountBadge) discountBadge.style.display = 'none';
      if (card.classList.contains('selected')) {
        var interest = totalPrice > 5000 ? 4 : 2;
        var interestNum = $('#interest_num');
        var moneyInstallment = $('#moneyInstallment');
        if (interestNum) interestNum.textContent = interest;
        if (moneyInstallment) moneyInstallment.textContent = C.formatMoney(Math.round(totalPrice / interest));
      }
    } else {
      bundleTotal.style.display = 'none';
      if (oldPriceEl) oldPriceEl.style.display = 'none';
      if (discountBadge) discountBadge.style.display = '';
    }

    for (var i = 1; i <= qty; i++) {
      var p = state.positions[i];
      var item = card.querySelector('.product-item[data-position="' + i + '"]');
      if (!item) continue;
      var priceEl = item.querySelector('.item-price');
      if (priceEl) priceEl.textContent = p.price ? C.formatMoney(Math.round(p.price * multiplier)) : '';
    }
  });
}

function updateAllThumbnails() {
  ['single', 'duo', 'trio'].forEach(function(bundle) {
    var qty = BUNDLE_QUANTITIES[bundle];
    for (var i = 1; i <= qty; i++) {
      var p = state.positions[i];
      var item = $('#' + bundle + '-details .product-item[data-position="' + i + '"]');
      if (!item || !p.personalizeImage) continue;
      var thumb = item.querySelector('.product-thumb');
      if (thumb) thumb.src = p.personalizeImage;
      var vt = item.querySelector('.variantText');
      if (vt) { vt.innerText = p.variantTitle; vt.style.display = 'block'; }
      var btn = item.querySelector('.personalize-btn');
      if (btn) { btn.textContent = 'Edit'; btn.classList.add('done'); }
    }
  });
}

// ===== LOAD OPTIONS =====
async function loadProductOptions(pos, handle) {
  if (!handle) return;
  if (Object.prototype.hasOwnProperty.call(optionsCache, handle)) {
    if (modalEls.dynamicForm.dataset.handle !== handle || !modalEls.dynamicForm.children.length) {
      C.renderOptions(modalEls.dynamicForm, optionsCache[handle]);
      modalEls.dynamicForm.dataset.handle = handle;
    }
    return optionsCache[handle];
  }
  try {
    var r = await fetch(C.API_BASE_URL + '/options?product=' + handle);
    var data = await r.json();
    optionsCache[handle] = data.options || [];
    C.renderOptions(modalEls.dynamicForm, optionsCache[handle]);
    modalEls.dynamicForm.dataset.handle = handle;
    return optionsCache[handle];
  } catch (e) { console.error(e); return null; }
}

// ===== MODAL =====
function resetModalUI() {
  modalEls.hacard.style.display = 'none';
  modalEls.loadingArea.style.display = 'none';
  setUploadedPreviewVisible(false);
  if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
  if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
  setReuseNote(false);
  if (modalEls.variantOption) modalEls.variantOption.classList.add('hide');
  if (modalEls.designActions) modalEls.designActions.style.display = 'none';
  if (modalEls.previewHistory) modalEls.previewHistory.hidden = true;
  if (modalEls.previewHistoryRow) modalEls.previewHistoryRow.innerHTML = '';
  if (modalEls.optionsContainer) modalEls.optionsContainer.style.display = 'none';
  if (modalEls.dynamicForm) modalEls.dynamicForm.style.display = '';
  if (modalEls.modalFooter) modalEls.modalFooter.style.display = '';
  if (modalEls.confirmBtn) {
    modalEls.confirmBtn.classList.remove('loading');
    modalEls.confirmBtn.disabled = isTeeTemplateMode();
    modalEls.confirmBtn.querySelector('.btn-text').textContent = 'Next';
  }
  C.setModalStep(modal, 1);
}

function showTeeUploadStep(posData) {
  C.setModalStep(modal, 1);
  if (isMultiPhotoActive()) {
    modalEls.multiPicker.hidden = false;
    if (!(posData.localPhotos || []).length) {
      var urls = normalizeUploadedUrls(posData.uploadedUrls);
      if (!urls.length && posData.uploadedUrl) urls = [posData.uploadedUrl];
      posData.localPhotos = urls.map(function(url) {
        return { previewUrl: url, uploadedUrl: url, reused: true };
      });
    }
    renderMultiPhotoGrid(posData);
    return;
  }

  if (isSinglePhotoActive()) {
    modalEls.singlePicker.hidden = false;
    if (!(posData.localPhotos || []).length) {
      var url = posData.uploadedUrl || posData.personalizeImage;
      if (url) posData.localPhotos = [{ previewUrl: url, uploadedUrl: posData.uploadedUrl || null, reused: true }];
    }
    renderSinglePhotoTile(posData);
  }
}

function ensureDefaultReuseButton() {
  if (modalEls.reuseNote || !modalEls.uploadedPreview) return modalEls.reuseNote;

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'hj-multi-upload__reuse-note caption-small';
  btn.setAttribute('data-reuse-upload-note', '');
  btn.setAttribute('data-action', 'reuse-upload-new');
  btn.hidden = true;
  btn.textContent = 'Re-upload';
  modalEls.uploadedPreview.insertAdjacentElement('afterend', btn);
  modalEls.reuseNote = btn;
  return btn;
}

function showDefaultUploadStep(posData) {
  C.hideUploadStatus(modal);
  C.setModalStep(modal, 1);
  if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
  if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
  if (modalEls.hacard) modalEls.hacard.style.display = 'none';
  if (modalEls.loadingArea) modalEls.loadingArea.style.display = 'none';
  if (modalEls.optionsContainer) modalEls.optionsContainer.style.display = 'none';
  if (modalEls.dynamicForm) modalEls.dynamicForm.style.display = '';
  if (modalEls.variantOption) modalEls.variantOption.classList.add('hide');
  if (modalEls.modalFooter) modalEls.modalFooter.style.display = '';
  if (modalEls.uploadedPreview && modalEls.uploadedPreviewImg && posData.uploadedUrl) {
    setUploadedPreviewVisible(true, posData.uploadedUrl);
  }

  ensureDefaultReuseButton();
  setReuseNote(!!posData.uploadedUrl);

  if (modalEls.confirmBtn) {
    modalEls.confirmBtn.classList.remove('loading');
    modalEls.confirmBtn.disabled = !posData.uploadedUrl;
    var label = modalEls.confirmBtn.querySelector('.btn-text');
    if (label) label.textContent = 'Next';
  }
}

function openModal(pos) {
  if (modal.open) closeModal();
  activePosition = pos;
  modal.dataset.position = pos;

  var posData = state.positions[pos];
  var handle = posData.productHandle;

  resetModalUI();
  injectVariantCards(handle);

  var forceGeneratedStep = posData.forceGeneratedStep === true;
  posData.forceGeneratedStep = false;

  if (posData.personalizeImage && isTeeTemplateMode() && !forceGeneratedStep) {
    showTeeUploadStep(posData);
  } else if (posData.personalizeImage) {
    ensureVariantCards(handle);
    C.setModalStep(modal, 3);
    modalEls.hacard.style.display = 'block';
    modalEls.mainImage.src = posData.personalizeImage;
    modalEls.mainImage.style.display = 'block';
    modalEls.prevBtn.style.visibility = posData.listGenerated.length > 1 ? 'visible' : 'hidden';
    modalEls.nextBtn.style.visibility = posData.listGenerated.length > 1 ? 'visible' : 'hidden';
    if (modalEls.variantOption) {
      if (isTeeTemplateMode()) modalEls.variantOption.classList.add('hide');
      else modalEls.variantOption.classList.remove('hide');
    }
    if (modalEls.modalFooter) modalEls.modalFooter.style.display = 'none';
    if (modalEls.designActions) modalEls.designActions.style.display = 'flex';
    renderPreviewHistory(posData);
    updateAddonPrices(pos);
    C.syncButtonUI(modal, '.print-type-btn', 'type', posData.printType);
    C.syncButtonUI(modal, '.size-btn', 'value', posData.sizeKey);
  } else if (posData.uploadedUrl) {
    if (isTeeTemplateMode()) {
      showTeeUploadStep(posData);
    } else {
      showDefaultUploadStep(posData);
    }
  } else {
    C.setModalStep(modal, 1);
    if (isMultiPhotoActive()) {
      modalEls.multiPicker.hidden = false;
      renderMultiPhotoGrid(posData);
      prefillLatestUpload(posData).then(function(prefilled) {
        if (activePosition !== pos || !isStepActive(1)) return;
        if (prefilled) renderMultiPhotoGrid(posData);
        else fileInput.click();
      });
    } else if (isSinglePhotoActive()) {
      modalEls.singlePicker.hidden = false;
      renderSinglePhotoTile(posData);
      prefillLatestUpload(posData).then(function(prefilled) {
        if (activePosition !== pos || !isStepActive(1)) return;
        if (prefilled) renderSinglePhotoTile(posData);
        else fileInput.click();
      });
    } else {
      prefillLatestUpload(posData).then(function(prefilled) {
        if (activePosition !== pos || !isStepActive(1)) return;
        if (prefilled) {
          showDefaultUploadStep(posData);
        } else {
          fileInput.click();
        }
      });
    }
    updateAddonPrices(pos);
  }

  if (C.lockPageScroll) C.lockPageScroll();
  modal.showModal();
}

function closeModal() {
  if (modal.open) modal.close();
  if (C.unlockPageScroll) C.unlockPageScroll();
  C.clearIntervals(intervals, activePosition);
  if (modalEls.confirmBtn) { modalEls.confirmBtn.classList.remove('loading'); modalEls.confirmBtn.disabled = false; }
  activePosition = null;
  modal.dataset.position = '';
}

// ===== PROCESS IMAGE =====
function processImage(pos) {
  var posData = state.positions[pos];
  C.processImage({
    posData: posData, modal: modal, intervals: intervals, key: pos,
    onComplete: function(imageUrl) {
      var completedImageUrl = imageUrl || posData.personalizeImage;
      if (completedImageUrl) posData.personalizeImage = completedImageUrl;
      ensureVariantCards(posData.productHandle);
      modal.querySelectorAll('input[data-option-key]').forEach(function(input) { input.value = ''; });
      updateAddonPrices(pos);
      if (modalEls.modalFooter) modalEls.modalFooter.style.display = 'none';
      if (modalEls.confirmBtn) modalEls.confirmBtn.classList.remove('loading');
      if (modalEls.variantOption) {
        if (isTeeTemplateMode()) modalEls.variantOption.classList.add('hide');
        else modalEls.variantOption.classList.remove('hide');
      }
      if (modalEls.designActions && !(isTeeMultiPhoto || isTeeSinglePhoto)) {
        modal.dataset.teeAutoCloseOnPreview = 'true';
        modalEls.designActions.style.display = 'flex';
      }
      renderPreviewHistory(posData);
      document.dispatchEvent(new CustomEvent('havjoy:personalize:complete', {
        detail: {
          position: pos,
          handle: posData.productHandle,
          imageUrl: completedImageUrl,
          variantId: posData.variantId,
          price: posData.price
        }
      }));
      var atcBtn = $('#atc-btn');
      if (atcBtn) { atcBtn.disabled = false; atcBtn.classList.add('attention-2'); }
      if (usesPdpVariantPicker && pos === 1) {
        syncPdpVariantPicker(pos);
      }
      if ((isTeeMultiPhoto || isTeeSinglePhoto || (usesPdpVariantPicker && pos === 1)) && modal.open && !posData.editingGenerated) {
        closeModal();
      }
    }
  });
}

function startPreviewGeneration(posData, pos) {
  C.hideUploadStatus(modal);
  if (modalEls.multiPicker) modalEls.multiPicker.hidden = true;
  if (modalEls.singlePicker) modalEls.singlePicker.hidden = true;
  setUploadedPreviewVisible(false);
  setReuseNote(false);
  posData.options = C.collectOptionValues(modal);
  posData.optionLabels = C.collectOptionLabels(modal);
  C.setModalStep(modal, 3);
  modal.querySelector('.generate-btn').onclick = function() {
    if (C.isProcessing(intervals, pos)) return false;
    if (modalEls.designActions) modalEls.designActions.style.display = 'none';
    processImage(pos);
  };
  if (modalEls.dynamicForm) modalEls.dynamicForm.style.display = 'none';
  if (modalEls.optionsContainer) modalEls.optionsContainer.style.display = 'none';
  if (modalEls.designActions) modalEls.designActions.style.display = 'none';
  processImage(pos);
}

// ===== ADD TO CART =====
async function addToCart() {
  var bundle = state.selectedBundle;
  var qty = BUNDLE_QUANTITIES[bundle];
  var atcBtn = $('#atc-btn');
  for (var i = 1; i <= qty; i++) {
    var p = state.positions[i];
    if (!p.personalizeImage) { C.showToast('Please personalize item ' + i + ' before adding to cart', 'warning'); return; }
    if (!p.variantId) { C.showToast('Please select a variant for item ' + i, 'warning'); return; }
  }
  var originalText = atcBtn.textContent;
  atcBtn.disabled = true; atcBtn.textContent = 'Adding...'; atcBtn.classList.remove('attention-2');
  try {
    var items = [];
    for (var i = 1; i <= qty; i++) {
      var p = state.positions[i];
      items.push({ id: p.variantId, quantity: 1, properties: C.buildCartProperties(p) });
    }
    await C.submitToCart(items);
    atcBtn.textContent = 'Added!';
    setTimeout(function() { atcBtn.textContent = originalText; atcBtn.disabled = false; }, 1500);
  } catch (e) {
    console.error('Error adding to cart:', e);
    C.showToast('Error adding to cart. Please try again.', 'error');
    atcBtn.textContent = originalText; atcBtn.disabled = false;
  }
}

// ===== INIT =====
function init() {
  if (usesPdpVariantPicker) {
    pdpVariantPicker.addEventListener('click', function(e) {
      var typeButton = e.target.closest('[data-pdp-print-type]');
      var sizeButton = e.target.closest('[data-pdp-size]');
      if (!typeButton && !sizeButton) return;

      e.preventDefault();
      var posData = state.positions[1];
      if (!posData || !posData.personalizeImage) return;

      if (typeButton) posData.printType = typeButton.dataset.pdpPrintType || 'canvas';
      if (sizeButton) posData.sizeKey = sizeButton.dataset.pdpSize || '9x12';
      updateAddonPrices(1);
      syncPdpVariantPicker(1);

      var atcBtn = $('#atc-btn');
      if (atcBtn) atcBtn.disabled = !posData.variantId;
    });
  }

  // Combo dropdown handler (dynamic options form)
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.combo-trigger');
    if (trigger) {
      var combo = trigger.closest('.combo');
      var open = combo.classList.contains('open');
      document.querySelectorAll('.combo.open').forEach(function(c) { c.classList.remove('open'); });
      document.querySelectorAll('.combo-trigger.active').forEach(function(t) { t.classList.remove('active'); });
      if (!open) { combo.classList.add('open'); trigger.classList.add('active'); }
      return;
    }
    var option = e.target.closest('.combo-option');
    if (option) {
      var combo = option.closest('.combo');
      combo.querySelectorAll('.combo-option').forEach(function(o) { o.classList.remove('active'); });
      option.classList.add('active');
      combo.querySelector('.combo-label').textContent = option.innerText.replace('\u2713', '').trim();
      var value = option.dataset.value;
      if (value) {
        var hiddenInput = combo.querySelector('.combo-input');
        if (hiddenInput) { hiddenInput.value = value; hiddenInput.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      combo.classList.remove('open');
      combo.querySelector('.combo-trigger').classList.remove('active');
      return;
    }
    if (!e.target.closest('.combo')) {
      document.querySelectorAll('.combo.open').forEach(function(c) { c.classList.remove('open'); });
      document.querySelectorAll('.combo-trigger.active').forEach(function(t) { t.classList.remove('active'); });
    }
  });

  function handleUploadTriggerClick(e, uploadBtn) {
    e.preventDefault();
    e.stopPropagation();
    var pos = parseInt(uploadBtn.dataset.position || '1', 10);
    var handle = uploadBtn.dataset.handle || productJson.handle;
    if (!state.positions[pos]) {
      if (!isTeeTemplateMode()) return;
      state.positions[pos] = createPositionState({ productHandle: handle });
    }
    state.positions[pos].productHandle = handle;
    if (uploadBtn.dataset.reuseMainUpload === 'true' && isTeeBundleBuilder && isTeeSinglePhoto && pos !== 1) {
      copyMainUploadToPosition(state.positions[pos]);
    }
    if (uploadBtn.dataset.openGenerated === 'true') {
      state.positions[pos].forceGeneratedStep = true;
      state.positions[pos].editingGenerated = true;
    } else {
      state.positions[pos].editingGenerated = false;
    }
    openModal(pos);
  }

  // Bundle card + upload-trigger clicks
  $('#bundle-options').addEventListener('click', function(e) {
    var card = e.target.closest('.bundle-card');
    if (card && !e.target.closest('.personalize-btn, .dropdown-btn, .upload-trigger')) {
      e.preventDefault(); e.stopPropagation();
      $$('.bundle-card').forEach(function(c) { c.classList.remove('selected'); });
      card.classList.add('selected');
      state.selectedBundle = card.dataset.bundle;
      $$('.bundle-details').forEach(function(d) { d.classList.remove('active'); });
      var details = $('#' + state.selectedBundle + '-details');
      if (details) details.classList.add('active');
      updateAllThumbnails(); updateBundlePrices();
      return;
    }
    var uploadBtn = e.target.closest('.upload-trigger');
    if (uploadBtn) {
      handleUploadTriggerClick(e, uploadBtn);
    }
  });

  document.addEventListener('click', function(e) {
    var uploadBtn = e.target.closest('.upload-trigger');
    if (!uploadBtn || uploadBtn.closest('#bundle-options')) return;
    handleUploadTriggerClick(e, uploadBtn);
  });

  function openPickerAfterReloadIfNeeded() {
    var shouldOpen = false;
    try {
      shouldOpen = window.sessionStorage.getItem('hjOpenPickerAfterReload') === '1';
      if (shouldOpen) window.sessionStorage.removeItem('hjOpenPickerAfterReload');
    } catch (error) {}
    if (!shouldOpen) return;

    var uploadBtn = document.querySelector('.upload-trigger');
    if (!uploadBtn) return;
    window.setTimeout(function() {
      uploadBtn.click();
    }, 350);
  }

  // File input (single, shared)
  fileInput.addEventListener('change', async function(e) {
    if (isMultiPhotoActive()) {
      if (activePosition === null) return;
      addMultiPhotoFiles(state.positions[activePosition], e.target.files);
      fileInput.value = '';
      return;
    }

    if (isSinglePhotoActive()) {
      if (activePosition === null) return;
      setSinglePhotoFile(state.positions[activePosition], e.target.files[0]);
      fileInput.value = '';
      return;
    }

    var f = e.target.files[0];
    if (!f || activePosition === null) return;
    var pos = activePosition;
    var posData = state.positions[pos];
    var localPreview = URL.createObjectURL(f);

    resetModalUI();
    C.setModalStep(modal, 1);
    if (modalEls.uploadedPreview && modalEls.uploadedPreviewImg) {
      setUploadedPreviewVisible(true, localPreview);
    }
    if (modalEls.confirmBtn) { modalEls.confirmBtn.classList.add('loading'); modalEls.confirmBtn.disabled = true; }

    try {
      var res = await C.handleFileUpload(f, uploader, modal);
      if (!res) { if (modalEls.confirmBtn) { modalEls.confirmBtn.classList.remove('loading'); modalEls.confirmBtn.disabled = false; } return; }
      URL.revokeObjectURL(localPreview);
      posData.uploadedUrl = res.url;
      setUploadedPreviewVisible(true, res.url);
      C.hideUploadStatus(modal);
      showDefaultUploadStep(posData);
      if (modalEls.confirmBtn) { modalEls.confirmBtn.classList.remove('loading'); modalEls.confirmBtn.disabled = false; }
      updateAddonPrices(pos);
    } catch (err) {
      console.error('Upload error:', err);
      C.hideUploadStatus(modal);
      C.showToast(C.uploadErrorMessage(err), 'error');
      if (modalEls.confirmBtn) { modalEls.confirmBtn.classList.remove('loading'); modalEls.confirmBtn.disabled = false; modalEls.confirmBtn.querySelector('.btn-text').textContent = 'Next'; }
      setUploadedPreviewVisible(false);
    }
    fileInput.value = '';
  });

  modal.addEventListener('click', function(e) {
    var addSingle = e.target.closest('[data-action="add-single-photo"]');
    if (addSingle && isSinglePhotoActive()) {
      e.preventDefault();
      fileInput.click();
      return;
    }

    var reuseUpload = e.target.closest('[data-action="reuse-upload-new"]');
    if (reuseUpload && activePosition !== null) {
      e.preventDefault();
      var reusePosData = state.positions[activePosition];
      if (isMultiPhotoActive()) {
        revokeLocalPhotos(reusePosData);
        reusePosData.localPhotos = [];
        reusePosData.uploadedUrls = [];
        reusePosData.uploadedUrl = null;
        renderMultiPhotoGrid(reusePosData);
      } else if (isSinglePhotoActive()) {
        revokeLocalPhotos(reusePosData);
        reusePosData.localPhotos = [];
        reusePosData.uploadedUrls = [];
        reusePosData.uploadedUrl = null;
        renderSinglePhotoTile(reusePosData);
      } else {
        reusePosData.uploadedUrls = [];
        reusePosData.uploadedUrl = null;
        setUploadedPreviewVisible(false);
        setReuseNote(false);
        if (modalEls.confirmBtn) modalEls.confirmBtn.disabled = true;
      }
      fileInput.click();
      return;
    }

    var startOver = e.target.closest('[data-action="tee-start-over"]');
    if (startOver && isTeeTemplateMode()) {
      e.preventDefault();
      try {
        window.sessionStorage.setItem('hjOpenPickerAfterReload', '1');
      } catch (error) {}
      window.location.reload();
      return;
    }

    var removeSingle = e.target.closest('[data-action="remove-single-photo"]');
    if (removeSingle && isSinglePhotoActive() && activePosition !== null) {
      e.preventDefault();
      var singlePosData = state.positions[activePosition];
      revokeLocalPhotos(singlePosData);
      singlePosData.localPhotos = [];
      singlePosData.uploadedUrls = [];
      singlePosData.uploadedUrl = null;
      renderSinglePhotoTile(singlePosData);
      return;
    }

    var add = e.target.closest('[data-action="add-multi-photo"]');
    if (add) {
      if (!isMultiPhotoActive()) return;
      e.preventDefault();
      fileInput.click();
      return;
    }

    var remove = e.target.closest('[data-action="remove-multi-photo"]');
    if (remove && activePosition !== null) {
      if (!isMultiPhotoActive()) return;
      e.preventDefault();
      var posData = state.positions[activePosition];
      var index = parseInt(remove.dataset.index || '-1', 10);
      if (index >= 0 && posData.localPhotos[index]) {
        if (!posData.localPhotos[index].reused && posData.localPhotos[index].previewUrl) {
          URL.revokeObjectURL(posData.localPhotos[index].previewUrl);
        }
        posData.localPhotos.splice(index, 1);
        syncUploadedUrlsFromPhotos(posData);
        renderMultiPhotoGrid(posData);
      }
    }
  });

  // Modal close button
  var closeBtn = modal.querySelector('[data-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  // Native dialog cancel (Escape key from browser)
  modal.addEventListener('cancel', function(e) { e.preventDefault(); closeModal(); });

  // Close + ATC (modal-atc-btn)
  var atcCloseBtn = modal.querySelector('.modal-atc-btn');
  if (atcCloseBtn) atcCloseBtn.addEventListener('click', function() {
    var pos = activePosition;
    closeModal();
    if (pos !== null && state.positions[pos] && state.positions[pos].variantId) addToCart();
  });

  // Confirm button
  modal.querySelector('.confirm-btn').addEventListener('click', async function() {
    var pos = activePosition;
    if (pos === null) return;
    var posData = state.positions[pos];

    if (posData.personalizeImage && !isStepActive(1)) {
      if (!posData.variantId) { C.showToast('Please select a variant', 'warning'); return; }
      closeModal();
      var qb = $('.qb-wrap');
      if (qb) qb.scrollIntoView();
      updateAllThumbnails(); updateBundlePrices(); return;
    }

    if (!isTeeTemplateMode() && isStepActive(1) && posData.uploadedUrl) {
      modalEls.confirmBtn.classList.add('loading');
      modalEls.confirmBtn.disabled = true;
      try {
        var loadedOptions = await loadProductOptions(pos, posData.productHandle) || [];
        if (activePosition !== pos) return;
        if (!loadedOptions.length) {
          C.showToast('Could not load personalization options. Please try again.', 'error');
          modalEls.confirmBtn.classList.remove('loading');
          modalEls.confirmBtn.disabled = false;
          return;
        }
        showDetailsStep(posData, pos);
      } catch (err) {
        console.error('Options load error:', err);
        C.showToast('Could not load personalization options. Please try again.', 'error');
        modalEls.confirmBtn.classList.remove('loading');
        modalEls.confirmBtn.disabled = false;
      }
      return;
    }

    if (isTeeTemplateMode() && isStepActive(1) && posData.uploadedUrl) {
      modalEls.confirmBtn.classList.add('loading');
      modalEls.confirmBtn.disabled = true;
      try {
        if (isMultiPhotoActive()) {
          var multiReady = await uploadMultiPhotos(posData);
          if (!multiReady) {
            modalEls.confirmBtn.classList.remove('loading');
            modalEls.confirmBtn.disabled = false;
            return;
          }
        } else if (isSinglePhotoActive()) {
          var singleReady = await uploadSinglePhoto(posData);
          if (!singleReady) {
            modalEls.confirmBtn.classList.remove('loading');
            modalEls.confirmBtn.disabled = false;
            return;
          }
        }
        await continueAfterOptionsLoaded(posData, pos);
      } catch (err) {
        console.error('Reused upload error:', err);
        C.hideUploadStatus(modal);
        C.showToast('Could not reuse your latest photo. Please upload again.', 'error');
        modalEls.confirmBtn.classList.remove('loading');
        modalEls.confirmBtn.disabled = false;
      }
      return;
    }

    if (isMultiPhotoActive() && !posData.uploadedUrl) {
      modalEls.confirmBtn.classList.add('loading');
      modalEls.confirmBtn.disabled = true;
      try {
        var uploaded = await uploadMultiPhotos(posData);
        if (!uploaded) {
          modalEls.confirmBtn.classList.remove('loading');
          modalEls.confirmBtn.disabled = false;
          return;
        }
        await continueAfterOptionsLoaded(posData, pos);
      } catch (err) {
        console.error('Multi-photo upload error:', err);
        C.hideUploadStatus(modal);
        C.showToast(C.uploadErrorMessage(err), 'error');
        modalEls.confirmBtn.classList.remove('loading');
        modalEls.confirmBtn.disabled = false;
      }
      return;
    }

    if (isSinglePhotoActive() && !posData.uploadedUrl) {
      modalEls.confirmBtn.classList.add('loading');
      modalEls.confirmBtn.disabled = true;
      try {
        var singleUploaded = await uploadSinglePhoto(posData);
        if (!singleUploaded) {
          modalEls.confirmBtn.classList.remove('loading');
          modalEls.confirmBtn.disabled = false;
          return;
        }
        await continueAfterOptionsLoaded(posData, pos);
      } catch (err) {
        console.error('Single-photo upload error:', err);
        C.hideUploadStatus(modal);
        C.showToast(C.uploadErrorMessage(err), 'error');
        modalEls.confirmBtn.classList.remove('loading');
        modalEls.confirmBtn.disabled = false;
      }
      return;
    }

    var currentOptions = optionsCache[posData.productHandle] || [];
    if (!isTeeTemplateMode() && currentOptions.length === 0) {
      currentOptions = await loadProductOptions(pos, posData.productHandle) || [];
      if (currentOptions.length > 0) showDetailsStep(posData, pos);
    }
    if (isTeeTemplateMode() && currentOptions.length === 0) {
      skipDetailsAndGenerate(posData, pos);
      return;
    }
    if (!isTeeTemplateMode() && currentOptions.length === 0) {
      C.showToast('Could not load personalization options. Please try again.', 'error');
      return;
    }

    var requiredInputs = modalEls.dynamicForm
      ? modalEls.dynamicForm.querySelectorAll('input[data-option-key][required]')
      : modal.querySelectorAll('input[data-option-key][required]');
    var hasErrors = false;
    requiredInputs.forEach(function(input) {
      if (!input.value.trim()) { input.style.borderColor = '#dc3545'; hasErrors = true; } else { input.style.borderColor = ''; }
    });
    if (hasErrors) { C.showToast('Please fill in all required fields', 'warning'); return; }
    if (!posData.uploadedUrl) { C.showToast('Please upload an image first', 'warning'); return; }

    modalEls.confirmBtn.classList.add('loading'); modalEls.confirmBtn.disabled = true;
    try {
      startPreviewGeneration(posData, pos);
    } catch (err) {
      console.error(err); C.showToast('Processing failed. Please try again.', 'error');
      modalEls.confirmBtn.classList.remove('loading'); modalEls.confirmBtn.disabled = false;
    }
  });

  // Download Now (delegated — injected dynamically)
  modal.addEventListener('click', function(e) {
    if (!e.target.closest('.download-now-btn')) return;
    var pos = activePosition;
    if (pos === null) return;
    var handle = state.positions[pos].productHandle;
    var dv = findVariant(handle, C.VARIANT_DIGITAL);
    if (!dv) { C.showToast('Digital variant not found', 'error'); return; }
    var btn = e.target.closest('.download-now-btn');
    btn.disabled = true; btn.textContent = 'Processing...';
    var posData = state.positions[pos];
    closeModal();
    C.submitToCart([{ id: dv.id, quantity: 1, properties: C.buildCartProperties(posData) }])
      .catch(function() { C.showToast('Failed to add to cart. Please try again.', 'error'); btn.disabled = false; btn.textContent = 'Download Now'; });
  });

  // Canvas ATC (delegated)
  modal.addEventListener('click', function(e) {
    if (!e.target.closest('.canvas-atc-btn')) return;
    var pos = activePosition;
    if (pos === null) return;
    var posData = state.positions[pos];
    var sizeInput = modal.querySelector('.addon-size[data-addon="canvas"]');
    var printTypeInput = modal.querySelector('.print-type-input');
    if (sizeInput) posData.sizeKey = sizeInput.value;
    if (printTypeInput) posData.printType = printTypeInput.value;
    updateAddonPrices(pos);
    closeModal();
    updateAllThumbnails(); addToCart();
  });

  // Print type buttons (delegated)
  modal.addEventListener('click', function(e) {
    var btn = e.target.closest('.print-type-btn');
    if (!btn) return;
    e.stopPropagation();
    var pos = activePosition;
    if (pos === null) return;
    var printType = btn.dataset.type;
    state.positions[pos].printType = printType;
    var printTypeInput = modal.querySelector('.print-type-input');
    if (printTypeInput) printTypeInput.value = printType;
    C.syncButtonUI(modal, '.print-type-btn', 'type', printType);
    updateAddonPrices(pos);
  });

  // Size buttons (delegated)
  modal.addEventListener('click', function(e) {
    var btn = e.target.closest('.size-btn');
    if (!btn) return;
    e.stopPropagation();
    var pos = activePosition;
    if (pos === null) return;
    var sizeKey = btn.dataset.value;
    state.positions[pos].sizeKey = sizeKey;
    var sizeInput = modal.querySelector('.addon-size[data-addon="canvas"]');
    if (sizeInput) sizeInput.value = sizeKey;
    C.syncButtonUI(modal, '.size-btn', 'value', sizeKey);
    updateAddonPrices(pos);
  });

  // Gallery nav
  if (modalEls.prevBtn) modalEls.prevBtn.addEventListener('click', function() {
    var pos = activePosition;
    if (pos === null) return;
    var p = state.positions[pos];
    var idx = p.galleryIndex - 1;
    selectPreviewHistory(p, idx);
  });
  if (modalEls.nextBtn) modalEls.nextBtn.addEventListener('click', function() {
    var pos = activePosition;
    if (pos === null) return;
    var p = state.positions[pos];
    var idx = p.galleryIndex + 1;
    selectPreviewHistory(p, idx);
  });

  if (modalEls.previewHistoryRow) modalEls.previewHistoryRow.addEventListener('click', function(e) {
    var thumb = e.target.closest('.hj-preview-history__thumb');
    if (!thumb) return;
    var pos = activePosition;
    if (pos === null) return;
    selectPreviewHistory(state.positions[pos], parseInt(thumb.dataset.previewIndex, 10));
  });

  // Product picker — open
  $$('.dropdown-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      $('#picker-position').value = btn.dataset.position;
      $('#picker-modal').classList.add('active');
    });
  });

  // Product picker — close
  var closePicker = function() { var pm = $('#picker-modal'); if (pm) pm.classList.remove('active'); };
  var pickerClose = $('.picker-close');
  var pickerOverlay = $('.picker-overlay');
  if (pickerClose) pickerClose.addEventListener('click', closePicker);
  if (pickerOverlay) pickerOverlay.addEventListener('click', closePicker);

  // Product picker — select
  $$('.product-card-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var pos = parseInt($('#picker-position').value);
      var handle = btn.dataset.handle;
      var img = btn.dataset.img;
      var title = btn.dataset.title;
      var posData = state.positions[pos];
      var oldHandle = posData.productHandle;

      if (oldHandle && oldHandle !== handle) state.positionCache[pos + '_' + oldHandle] = Object.assign({}, posData);
      var cached = state.positionCache[pos + '_' + handle];
      state.positions[pos] = cached ? Object.assign({}, cached) : createPositionState({ productHandle: handle });

      ['duo', 'trio'].forEach(function(bundle) {
        var el = $('#' + bundle + '-details .product-item[data-position="' + pos + '"]');
        if (!el) return;
        var thumb = el.querySelector('.product-thumb');
        if (thumb) thumb.src = (cached && cached.personalizeImage) ? cached.personalizeImage : img;
        var truncate = el.querySelector('.truncate');
        if (truncate) truncate.textContent = title;
        var pbtn = el.querySelector('.personalize-btn');
        if (pbtn) {
          pbtn.dataset.handle = handle;
          if (cached && cached.personalizeImage) { pbtn.textContent = 'Edit'; pbtn.classList.add('done'); }
          else { pbtn.textContent = 'Upload Image'; pbtn.classList.remove('done'); }
        }
      });

      if (activePosition === pos) {
        variantCardsHandle = null;
        resetModalUI();
        injectVariantCards(handle);
        loadProductOptions(pos, handle);
        updateAddonPrices(pos);
      }

      updateBundlePrices(); closePicker();
    });
  });

  // Form submit
  var bundleForm = $('#bundle-form');
  if (bundleForm) bundleForm.addEventListener('submit', function(e) { e.preventDefault(); addToCart(); });

  // Buy more text
  var buyMoreText = $('#buy_more_text');
  if (buyMoreText) buyMoreText.addEventListener('click', function() {
    $$('.bundle-card').forEach(function(card) { card.style.display = 'block'; });
    buyMoreText.style.display = 'none';
  }, { once: true });

  // Init first bundle details panel
  var details = $('#' + state.selectedBundle + '-details');
  if (details) details.classList.add('active');

  // Global Escape
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    closePicker();
    if (modal.open) closeModal();
  });

  // Attention animation on first personalize button
  setTimeout(function() {
    var firstBtn = $('.personalize-btn:not(.done)');
    if (firstBtn) {
      firstBtn.classList.add('attention');
      firstBtn.addEventListener('animationend', function() { firstBtn.classList.remove('attention'); }, { once: true });
      firstBtn.addEventListener('click', function() { firstBtn.classList.remove('attention'); }, { once: true });
    }
  }, 800);

  openPickerAfterReloadIfNeeded();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

})();
